import createPersistedState from 'vuex-persistedstate'
import filter from './persistStateFilter'
import migrateState from './migrateState'

// Do not change unless you coordinate with FastForward!
const key = 'dextra-mfv'

export default function getPlugins() {
  migrateState()

  return [createPersistedState({ key, filter })]
}
